export default __webpack_public_path__ + "locales/ko-KR/DownloadDialog.json?hash=d2bc3c07ef43d9cd464ce837baae5ff1";